import { supabase } from '../lib/supabase';

export const locationReviewService = {
  /**
   * Get all location reviews with pagination and search
   * @param {number} page - Page number (1-indexed)
   * @param {number} pageSize - Number of items per page
   * @param {string} searchQuery - Search query for filtering
   * @returns {Promise<{data: Array, count: number, error: any}>}
   */
  async getAll(page = 1, pageSize = 10, searchQuery = '') {
    try {
      const from = (page - 1) * pageSize;
      const to = from + pageSize - 1;

      let query = supabase?.from('location_reviews')?.select('*', { count: 'exact' });

      // Apply search filter
      if (searchQuery && searchQuery?.trim() !== '') {
        const search = searchQuery?.trim();
        query = query?.or(
          `client_name.ilike.%${search}%,review_text.ilike.%${search}%,location.ilike.%${search}%`
        );
      }

      // Apply sorting - newest first
      query = query?.order('created_at', { ascending: false })?.range(from, to);

      const { data, error, count } = await query;

      if (error) throw error;

      // Convert snake_case to camelCase
      const reviews = data?.map(row => ({
        id: row?.id,
        clientName: row?.client_name,
        rating: row?.rating,
        reviewText: row?.review_text,
        location: row?.location,
        createdAt: row?.created_at,
        updatedAt: row?.updated_at
      })) || [];

      return { data: reviews, count, error: null };
    } catch (err) {
      console.error('Error fetching location reviews:', err);
      return { data: [], count: 0, error: err };
    }
  },

  /**
   * Get review count
   * @returns {Promise<{count: number, error: any}>}
   */
  async getCount() {
    try {
      const { count, error } = await supabase?.from('location_reviews')?.select('*', { count: 'exact', head: true });

      if (error) throw error;

      return { count: count || 0, error: null };
    } catch (err) {
      console.error('Error fetching location review count:', err);
      return { count: 0, error: err };
    }
  }
};